import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { observer } from 'mobx-react';
import get from 'lodash/get';

import joinPath from 'utilities/joinPath';

import Sidebar from 'components/sidebar/Sidebar';
import SidebarLink from 'components/sidebar/SidebarLink';


const SubpageSidebar = observer(({ page }) => {
    const match = useRouteMatch();
    
    return (
        <Sidebar>
            {page.children?.map((childPage) => {
                const menuIcon = get(childPage, 'acf.menu_icon.url', false);
                const title = get(childPage, 'title.rendered', childPage.slug);
                
                return (
                    <SidebarLink
                        key={childPage.slug}
                        to={joinPath(match.path, childPage.slug)}   
                        icon={menuIcon}
                        text={title}
                    />
                );
            })}
        </Sidebar>
    );
});


export default SubpageSidebar;
